// Protected Route - Guards admin-only routes
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
    const { user, isAdmin, isModerator, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: '#FFF5F5'
                }}
            >
                <CircularProgress sx={{ color: '#FF6B9D', mb: 2 }} />
                <Typography color="text.secondary">Verifying access...</Typography>
            </Box>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requireAdmin && !isAdmin) {
        return (
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: '#FFF5F5'
                }}
            >
                <Typography variant="h4" color="error" gutterBottom>
                    Access Denied
                </Typography>
                <Typography color="text.secondary">
                    This page requires full admin privileges.
                </Typography>
            </Box>
        );
    }

    if (!isAdmin && !isModerator) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
